import React from 'react';
import StockChart from './StockChart';
import OverviewContent from './OverviewContent';
import styles from './Overview.module.scss';

export default function Overview() {

  const renderValues = (title: string, value: string, arrowColor: string) => {
    return (
      <div>
        <h3 className={styles.title}>{title}</h3>
        <div className={`${styles.value} fw-300`}>
          {value}
          <span className={arrowColor}>
            <i className="icon-arrow-up-right"></i>
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="ph-5">
      <div className="row mt-5" style={{ width: '20%', margin: 'auto' }}>
        <div className="col">
          {renderValues('Overall', '760', 'text-error')}
        </div>
        <div className="col">
          {renderValues('Lowest', '600', 'text-gray-500')}
        </div>
        <div className="col">
          {renderValues('Highest', '857', 'text-gray-500')}
        </div>
      </div>
      <StockChart />
      <OverviewContent />
    </div>
  );
}
